window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function ($) {
  function isDevSite() {
    return window.location.hostname === "gabrielahearst-dev-test.myshopify.com";
  }

  function getAccessToken() {
    return isDevSite()
      ? "77c96b0c306326ea7ec725321bb24abc"
      : "c9dd539222fd66d774097f24847ca363";
  }

  function deParams(str) {
    return str
      .replace(/(^\?)/, "")
      .split("&")
      .map(
        function (n) {
          return (n = n.split("=")), (this[n[0]] = n[1]), this;
        }.bind({})
      )[0];
  }

  $(function () {
    $(document).on(
      "click",
      ".collection-header__filtering, .filtering-header__close, .filtering-no-result-link",
      function (e) {
        e.preventDefault();
        $(".widget--filtering").toggleClass("visible");
      }
    );

    $(".collection-header__filtering span").on("click", function () {
      $(".widget--filtering");
    });

    $(document).on(
      "click",
      ".collection-header__sorting, .sorting-header__close",
      function (e) {
        if (window.innerWidth < 960) {
          // e.preventDefault();
          e.stopPropagation();
          $(".widget--sorting").toggleClass("visible");
        }
      }
    );

    $(document).on("click", ".filtering-group h3", function (e) {
      e.preventDefault();

      $(this).toggleClass("visible").next().slideToggle();
    });

    REBASE.theme.collection = {
      handle: $(".products").data("collection"),
      products: [],
      renderedProducts: {},
      displayedProducts: [],
      collectionTags: [],
      filterGroups: {},
      filters: [],
      sortKeys: ["price_asc", "price_desc", "title_asc", "title_desc"],
      sortBy: "",

      init: function () {
        REBASE.theme.collection.fetchInitialFilters();
        REBASE.theme.collection.fetchInitialSort();
        REBASE.theme.collection.checkSelectedFilters();
        REBASE.theme.collection.setSelectedSort();
        REBASE.theme.collection.fetchProducts();
        REBASE.theme.collection.bindEvents();
      },

      bindEvents: function () {
        $(document).on(
          "collectionFetchProductsComplete",
          REBASE.theme.collection.compileProducts
        );
        $(document).on(
          "collectionFetchProductsComplete",
          REBASE.theme.collection.renderSizeFilters
        );
        $(document).on(
          "collectionFetchProductsComplete",
          REBASE.theme.collection.filterProducts
        );
        $(document).on(
          "collectionFilterProductsComplete",
          REBASE.theme.collection.sortProducts
        );
        $(document).on(
          "collectionSortProductsComplete",
          REBASE.theme.collection.renderProducts
        );
        $(document).on(
          "click",
          ".filtering-list li",
          REBASE.theme.collection.handleClickFilter
        );
        $(document).on(
          "change",
          "#sort-by-select",
          REBASE.theme.collection.handleChangeSort
        );
      },

      fetchProducts: function (cursor) {
        var cursorParam = "";
        if (typeof cursor != "undefined") {
          cursorParam = ' after: "' + cursor + '"';
        }

        var query = `{
          collectionByHandle(handle: "${REBASE.theme.collection.handle}") {
            handle
            products( first:250 ${cursorParam} ) {
              pageInfo {
                hasNextPage
                hasPreviousPage
              }
              edges{
                cursor
                node {
                  availableForSale
                  productType
                  id
                  handle
                  title
                  onlineStoreUrl
                  tags
                  options(first: 3) {
                    name
                    values
                  }
                  metafields(first: 250) {
                    edges {
                        node {
                            namespace
                            key
                            value
                        }
                    }
                  }
                  variants(first:20) {
                    edges {
                      node {
                        availableForSale
                        selectedOptions {
                          name
                          value
                        }
                      }
                    }
                  }
                  images(first:2) {
                    edges {
                      node {
                        altText
                        transformedSrc(maxWidth: 800)
                      }
                    }
                  }
                  priceRange{
                    minVariantPrice{
                      amount
                      currencyCode
                    }
                  }
                  compareAtPriceRange{
                    minVariantPrice{
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }`;

        $.ajax("https://gabrielahearst.com/api/2021-07/graphql.json", {
          contentType: "application/json",
          type: "POST",
          headers: {
            "X-Shopify-Storefront-Access-Token": getAccessToken(),
          },
          data: JSON.stringify({ query: query }),
          success: function (response) {
            var cursor = "";
            var filteredProducts;
            var templateProtected = document.querySelector(
              "[data-template-protected]"
            );
            if (!templateProtected) {
              filteredProducts = REBASE.theme.collection.filterExcludedProducts(
                response.data.collectionByHandle.products.edges
              );
              filteredProducts =
                REBASE.theme.collection.filterSaleExcludedProducts(
                  response.data.collectionByHandle.handle,
                  filteredProducts
                );
            } else {
              filteredProducts =
                response.data.collectionByHandle.products.edges;
            }
            filteredProducts.forEach(function (edge) {
              REBASE.theme.collection.products.push(edge.node);
              cursor = edge.cursor;
            });

            if (
              response.data.collectionByHandle.products.pageInfo.hasNextPage
            ) {
              REBASE.theme.collection.fetchProducts(cursor);
            } else {
              $(document).trigger("collectionFetchProductsComplete");
            }
          },
        });
      },

      filterExcludedProducts: function (products) {
        let excludedTag = "onsale-excluded";
        return products.filter(
          (p) => !p.node.tags.find((tag) => tag === excludedTag)
        );
      },

      // Using `show-only-collection:[collection-handle] tag
      // filter out products that are 'only' in a sale collection
      filterSaleExcludedProducts: function (handle, products) {
        const exclusiveSaleTag = "only-show-collection";

        return products.filter((p) => {
          const salesTag = p.node.tags.find(
            (tag) => tag.indexOf(exclusiveSaleTag) > -1
          );

          if (!salesTag || (salesTag && salesTag.indexOf(handle) > -1)) {
            return true;
          }

          return false;
        });
      },

      fetchInitialFilters: function () {
        var urlFilters = deParams(window.location.search);
        var collection_tags = $(".products").data("tags");

        urlFilters.hasOwnProperty("filters") &&
          decodeURIComponent(urlFilters.filters)
            .split(",")
            .forEach(function (filter) {
              filter.trim() !== "" &&
                REBASE.theme.collection.filters.push(decodeURI(filter));
            });

        collection_tags.forEach(function (tag) {
          REBASE.theme.collection.collectionTags.push(tag);
        });
      },

      fetchInitialSort: function () {
        REBASE.theme.collection.sortBy =
          deParams(window.location.search).sortBy || "";
      },

      checkSelectedFilters: function () {
        $(".filtering-list li").each(function (indx, item) {
          REBASE.theme.collection.filters.forEach(function (filter) {
            if (
              $(item).data("group") === filter.split("|")[0] &&
              $(item).data("tag") === filter.split("|")[1]
            ) {
              $(item).addClass("active");
            }
          });
        });
      },

      setSelectedSort: function () {
        var selected,
          container = $("#sort-by-select").parents(".dropdown");
        if (REBASE.theme.collection.sortBy == "") {
          return false;
        }

        selected = $(
          '.dropdown--sort:not(.widget--sorting) .dropdown__list-item[data-value="' +
            REBASE.theme.collection.sortBy +
            '"]'
        );
        if (selected.length) {
          selected.addClass("dropdown__list-item--selected");
        }
      },

      sortProducts: function () {
        var sortedProducts = REBASE.theme.collection.displayedProducts;

        // if empty, return original set
        // if not empty, and not a valid sort key, return original set
        if (
          REBASE.theme.collection.sortBy === "" ||
          !REBASE.theme.collection.sortKeys.includes(
            REBASE.theme.collection.sortBy
          )
        ) {
          $(document).trigger("collectionSortProductsComplete");
          return;
        }

        try {
          switch (REBASE.theme.collection.sortBy) {
            case "price_asc":
              sortedProducts = _.sortBy(sortedProducts, function (i) {
                return parseInt(i.priceRange.minVariantPrice.amount);
              });
              break;
            case "price_desc":
              sortedProducts = _.sortBy(sortedProducts, function (i) {
                return parseInt(i.priceRange.minVariantPrice.amount);
              }).reverse();
              break;
            case "title_asc":
              sortedProducts = _.sortBy(sortedProducts, ["title"]);
              break;
            case "title_desc":
              sortedProducts = _.sortBy(sortedProducts, ["title"]).reverse();
              break;
            default:
              console.error("Not a valid sort key");
          }
        } catch (e) {
          console.warn("Error sorting products: ", e.message);
          $(document).trigger("collectionSortProductsComplete");
        }

        REBASE.theme.collection.displayedProducts = sortedProducts;
        $(document).trigger("collectionSortProductsComplete");
      },

      filterProducts: function () {
        var filterGroups = {};
        var displayedProducts = REBASE.theme.collection.products;

        // initial filter for collectionTags
        if (REBASE.theme.collection.collectionTags.length) {
          displayedProducts = displayedProducts.filter(function (product) {
            return _.intersection(
              REBASE.theme.collection.collectionTags,
              product.tags
            ).length;
          });
        }

        // additional filtering by our own Filter UI / URL params
        if (REBASE.theme.collection.filters.length) {
          // group our filters together into groups
          REBASE.theme.collection.filters.forEach(function (filter) {
            var filterSplit = filter.split("|"),
              group = filterSplit[0],
              value = filterSplit[1];
            filterGroups[group] = filterGroups[group] || [];
            filterGroups[group].indexOf(value) === -1 &&
              filterGroups[group].push(value);
          });

          // for each group, progressively filter down
          for (var group in filterGroups) {
            if (filterGroups.hasOwnProperty(group) && group !== "size") {
              displayedProducts = displayedProducts.filter(function (product) {
                return _.intersection(filterGroups[group], product.tags).length;
              });
            }
            if (filterGroups.hasOwnProperty(group) && group === "size") {
              displayedProducts = displayedProducts.filter(function (product) {
                return _.intersection(
                  filterGroups[group],
                  product.sizes
                ).length;
              });
            }
          }
        }

        // set our main key to our new filtered array
        REBASE.theme.collection.displayedProducts = displayedProducts;
        $(document).trigger("collectionFilterProductsComplete");
      },

      getProductUrlInCollection: function (productHandle) {
        return (
          "/collections/" +
          REBASE.theme.collection.handle +
          "/products/" +
          productHandle
        );
      },

      // Hydrates HTML template with data, and stores the results to reference later
      compileProducts: function () {
        REBASE.theme.collection.products.forEach(function (product) {
          var product_item_template = $("#product_item_template").html();
          var compiled_html = _.template(product_item_template);
          REBASE.theme.collection.renderedProducts[product.id] = compiled_html({
            prod: product,
          });
        });
      },

      // Maps our sorted/filtered products to our pre-rendered HTML data and inserts in DOM
      renderProducts: function () {
        // console.log(REBASE.theme.collection.displayedProducts)

        // empty previous products
        $(".row.products").empty();

        if (REBASE.theme.collection.displayedProducts.length) {
          // render template for articles and append
          REBASE.theme.collection.displayedProducts.forEach(function (product) {
            $(".row.products").append(
              REBASE.theme.collection.renderedProducts[product.id]
            );
          });

          if (
            window.collection_loop_promos &&
            window.collection_loop_promos.length
          ) {
            REBASE.theme.collection.insertPromos();
          }

          // update the lazyLoad instance to catch new dom elements
          window.rehash_lazyLoad.update();

          // Once products are rendered, scroll to position and save
          // that to local storage
          // These functions are in theme-custom.js
          scrolltoPosition();
          saveScrollPosition();

          document.addEventListener("scroll", () => {
            saveScrollPosition(true), 200;
          });
        } else {
          $(".row.products").append(
            '<p class="products--no-result-message">Sorry, your applied filters returned no results. Please <a href="#" class="filtering-no-result-link">adjust your filters</a>.</p>'
          );
        }
      },

      insertPromos: function () {
        window.collection_loop_promos.forEach(function (promo) {
          $(".products .product:nth-child(" + promo.position + ")").before(
            promo.html
          );
        });
      },

      updateUrlParams: function () {
        var params = {};

        if (REBASE.theme.collection.filters.length) {
          params.filters = REBASE.theme.collection.filters.join(",");
        }

        if (REBASE.theme.collection.sortBy !== "") {
          params.sortBy = REBASE.theme.collection.sortBy;
        }

        window.history.replaceState({}, document.title, "?" + $.param(params));
      },

      handleClickFilter: function (e) {
        var _this = $(e.currentTarget),
          tag = _this.data("tag"),
          group = _this.data("group"),
          filterIndex,
          collectionTagIndex;

        e.preventDefault();

        if (_this.hasClass("active")) {
          filterIndex = REBASE.theme.collection.filters.indexOf(
            group + "|" + tag
          );
          collectionTagIndex =
            REBASE.theme.collection.collectionTags.indexOf(tag);

          if (filterIndex > -1) {
            REBASE.theme.collection.filters.splice(filterIndex, 1);
          }

          if (collectionTagIndex > -1) {
            REBASE.theme.collection.collectionTags.splice(
              collectionTagIndex,
              1
            );
          }
        } else {
          REBASE.theme.collection.filters.push(group + "|" + tag);
        }

        _this.toggleClass("active");
        REBASE.theme.collection.filterProducts();
        REBASE.theme.collection.updateUrlParams();
      },

      handleChangeSort: function (e) {
        REBASE.theme.collection.sortBy = $(e.currentTarget).val();

        REBASE.theme.collection.sortProducts();
        REBASE.theme.collection.updateUrlParams();
      },

      groupFilters() {
        // group our filters together into groups
        const filterGroups = {};
        REBASE.theme.collection.filters.forEach(function (filter) {
          var filterSplit = filter.split("|"),
            group = filterSplit[0],
            value = filterSplit[1];
          filterGroups[group] = filterGroups[group] || [];
          filterGroups[group].indexOf(value) === -1 &&
            filterGroups[group].push(value);
        });
        REBASE.theme.collection.filterGroups = filterGroups;
      },

      renderSizeFilters() {
        REBASE.theme.collection.getUniqueSizes();
        REBASE.theme.collection.sortSizes();
        REBASE.theme.collection.groupFilters();
        REBASE.theme.collection.compileSizesTemplate();
      },

      getUniqueSizes() {
        let sizes = [];
        // map sizes to products object fot easy filtering
        REBASE.theme.collection.products = REBASE.theme.collection.products.map(
          (product) => {
            let sizeOption = product.variants.edges.reduce((acc, { node }) => {
              let option = node.selectedOptions.find(
                (o) => o.name.toLowerCase() === "size"
              );
              if (node.availableForSale && option && option.value) {
                return [...acc, option.value];
              }
              return acc;
            }, []);
            return { ...product, sizes: sizeOption };
          }
        );
        REBASE.theme.collection.products.forEach((item) => {
          sizes = [...sizes, ...item.sizes];
        });
        // save only unique sizes
        sizes = Array.from(new Set(sizes));
        REBASE.theme.collection.sizes = sizes;
      },

      sortSizes() {
        function sortArray(array, pattern) {
          return array.sort(function (a, b) {
            if (pattern.indexOf(a) === pattern.indexOf(b)) {
              return 0;
            } else {
              return pattern.indexOf(a) > pattern.indexOf(b) ? 1 : -1;
            }
          });
        }
        REBASE.theme.collection.sizes = sortArray(
          REBASE.theme.collection.sizes,
          window.sortPattern
        );
      },

      compileSizesTemplate() {
        const filterTemplate = $("#filter-template").html();
        const compiledHtml = _.template(filterTemplate)({
          sizes: REBASE.theme.collection.sizes,
          isSelected: REBASE.theme.collection.isSelected,
        });
        $(compiledHtml).insertAfter($(".filtering-group").last());
      },

      isSelected(size) {
        const selectedSizes =
          REBASE.theme.collection.filterGroups["size"] || [];
        return selectedSizes.includes(size);
      },
    };

    // if ( $('body').hasClass('collection-template') && !$('body').hasClass('collection-protected-template') ) {
    //   REBASE.theme.collection.init();
    // }

    $(document).on("protected_password_validated", function () {
      $(".protected").fadeOut(function () {
        $(this).remove();
        $(".product--skeleton").removeClass("product--skeleton-hidden");
        REBASE.theme.collection.init();
      });
    });

    const toggle = document.querySelector("#plp-toggle");
    if (toggle && toggle.dataset.filtersToggle !== "boost") {
      toggle.addEventListener("change", function () {
        let productImages = document.querySelectorAll(
          ".product__image-wrapper[data-model-view-container]"
        );
        let productSlider = document.querySelectorAll(
          ".product__content .swiper-container"
        );

        productSlider.forEach((slider) => {
          slider.classList.toggle("d-none");
        });

        productImages.forEach((productImage) => {
          productImage.classList.toggle("d-none");

          allProductImages = productImage.querySelectorAll("img");
          for (let i = 0; i < allProductImages.length; i++) {
            if (allProductImages[0].classList.contains("hiddenMainImage")) {
              allProductImages[0].classList.remove("hiddenMainImage");
              allProductImages[1].classList.remove("hiddenHoverImage");
              allProductImages[2].classList.add("hiddenMainImage");
              allProductImages[3].classList.add("hiddenHoverImage");
              break;
            } else {
              allProductImages[0].classList.add("hiddenMainImage");
              allProductImages[1].classList.add("hiddenHoverImage");
              allProductImages[2].classList.remove("hiddenMainImage");
              allProductImages[3].classList.remove("hiddenHoverImage");
              break;
            }
          }
        });
      });
    }

    const mobileToggle = document.querySelector("#plp-toggle-mobile");
    if (mobileToggle) {
      mobileToggle.addEventListener("change", function () {
        let productImages = document.querySelectorAll(
          ".product__image-wrapper"
        );
        let productSlider = document.querySelectorAll(
          ".product__content .swiper-container"
        );

        productSlider.forEach((slider) => {
          slider.classList.toggle("d-none");
        });

        productImages.forEach((productImage) => {
          productImage.classList.toggle("d-none");

          allProductImages = productImage.querySelectorAll("img");

          if (allProductImages[0].classList.contains("hiddenMainImage")) {
            allProductImages[0].classList.remove("hiddenMainImage");
            allProductImages[1].classList.remove("hiddenHoverImage");
            allProductImages[2].classList.add("hiddenMainImage");
            allProductImages[3].classList.add("hiddenHoverImage");
          } else {
            allProductImages[0].classList.add("hiddenMainImage");
            allProductImages[1].classList.add("hiddenHoverImage");
            allProductImages[2].classList.remove("hiddenMainImage");
            allProductImages[3].classList.remove("hiddenHoverImage");
          }
        });
      });
    }

    window.scrapeSectionData = (container) => {
      const dataEl = container.parentNode.querySelector("[data-section-data]");
      if (!dataEl) return {};

      const loader = document.getElementById("loader-lookbook");
      loader.classList.add("active");

      try {
        const data = JSON.parse(dataEl.textContent);
        loader.classList.remove("active");

        return data;
      } catch {
        console.warn(
          `Error parsing data for ${container.dataset.sectionType} ${container.dataset.sectionId}`
        );
        loader.classList.remove("active");
        return {};
      }
    };
    const lookbookProducts = document.querySelectorAll(
      ".collection-product-box"
    );
    if (lookbookProducts) {
      const wrapper = document.querySelector(".collection-product-wrap");
      const lookbookModal = document.querySelector(
        ".collection-product-drawer"
      );
      const lookbookModalImage = document.querySelector(
        ".collection-product-drawer__image img"
      );
      const lookbookModalTitle = document.querySelector(
        ".collection-product-drawer__title"
      );
      const lookbookModalOverlay = document.querySelector(
        ".collection-product-drawer__overlay"
      );
      const lookbookModalClose = document.querySelector(
        ".collection-product-drawer__close"
      );
      function closeModal() {
        lookbookModal.classList.remove("active");
        lookbookModalOverlay.classList.remove("active");
        if (window.lookbookModalSwiper) {
          const swiperWrapper = document.querySelector(
            "[data-lookbook-swiper-wrapper]"
          );
          swiperWrapper.innerHTML = "";
          window.lookbookModalSwiper.destroy(true, false);
        }
      }
      lookbookModalClose?.addEventListener("click", function () {
        closeModal();
      });
      lookbookModalOverlay?.addEventListener("click", function () {
        closeModal();
      });

      lookbookProducts.forEach((product) => {
        const productId = Number(product.dataset.productId);
        const data = scrapeSectionData(wrapper);
        const productData = data.data.products.find(
          (product) => product.id === productId
        );
        if (!productData.styled_with) {
          product
            .querySelector(".collection-product-box__image-wrapper")
            .classList.add("no-style");
          product
            .querySelector(".collection-product-box__title")
            .classList.add("no-style");
        }
        product.addEventListener("click", function () {
          if (!productData.styled_with) {
            return;
          }
          const relatedProducts = productData.styled_with.split("|");
          lookbookModal.classList.add("active");
          lookbookModalOverlay.classList.add("active");
          lookbookModalTitle.innerHTML = productData.title;
          lookbookModalImage.src = productData.featured_image;
          let swiperContainer = document.querySelector(
            ".collection-product-drawer__carousel"
          );
          let slides = relatedProducts;
          swiperContainer.innerHTML = "";

          const slidesContainer = document.querySelector(
            ".collection-product-drawer__carousel"
          );
          const prevButton = document.querySelector(".slide-arrow-prev");
          const nextButton = document.querySelector(".slide-arrow-next");

          if (slides.length < 4) {
            prevButton.disabled = true;
            nextButton.disabled = true;
          }

          slides.forEach(function (slide) {
            let query = `{
            productByHandle(handle: "${slide}") {
              id
              title
              description
              handle
              featuredImage {
                url
                altText
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    sku
                    availableForSale
                    quantityAvailable
                  }
                }
              }
            }
          }`;
            $.ajax("https://gabrielahearst.com/api/2023-04/graphql.json", {
              contentType: "application/json",
              type: "POST",
              headers: {
                "X-Shopify-Storefront-Access-Token": getAccessToken(),
              },
              data: JSON.stringify({ query: query }),
              success: function (response) {
                if (!response.data.productByHandle) return;
                let slideElement = document.createElement("div");
                slideElement.classList.add("item-slide");
                let variants = response.data.productByHandle.variants.edges;

                slideElement.innerHTML = `
                    <form
                      id="minicart-add-to-cart-form"
                      class="collection-product-drawer__slider-item"
                      action="/cart/add"
                      method="post"
                      data-variant-form
                    >
                      <input type="hidden" name="quantity" value="1" />
                      <div class="collection-product-drawer__slider-img">
                        <a href="/products/${
                          response.data.productByHandle.handle
                        }">
                          <img src="${
                            response.data.productByHandle.featuredImage.url
                          }" alt="${
                  response.data.productByHandle.featuredImage.altText
                }">
                        </a>
                      </div>
                      <div class="collection-product-drawer__slider-title">${
                        response.data.productByHandle.title
                      }</div>
                      <div class="collection-product-drawer__slider-price">$${
                        variants[0].node.price.amount
                      }</div>
                      <div class="collection-product-drawer__slider-size">
                        <span>Size</span>
                        <div id="variant-selector" class="collection-product-drawer__variant-selector">
                          ${variants
                            .map((variant, index) => {
                              const checked = index === 0 ? "checked" : "";
                              return `<label>
                              <input type="radio" ${
                                !variant.node.availableForSale
                                  ? "disabled"
                                  : " "
                              } name="id" value="${
                                decodeURIComponent(variant.node.id).split(
                                  "gid://shopify/ProductVariant/"
                                )[1]
                              }" ${checked}>
                              <span>${variant.node.title.split(" ")[0]}</span>
                            </label>`;
                            })
                            .join("")}
                        </div>
                      </div>
                      <div class="collection-product-drawer__slider-atc">
                        <button id="add-to-cart" class="btn--add-to-cart" type="submit">
                          <span class="minicart-add-to-cart-text" data-add-to-cart-text="Add to bag">Add to Bag</span>
                        </button>
                      </div>
                    </form>
                  `;
                swiperContainer.appendChild(slideElement);

                const variantSelectorInputs = slideElement.querySelectorAll(
                  "#variant-selector input"
                );
                const variantSelectorInput = slideElement.querySelector(
                  "#variant-selector input"
                );
                const variantSelectorButton =
                  slideElement.querySelector("#add-to-cart");
                if (variantSelectorInput.disabled) {
                  variantSelectorButton.classList.add("disabled");
                } else {
                  variantSelectorButton.classList.remove("disabled");
                }
                variantSelectorInputs.forEach((variantSelectorInput) => {
                  variantSelectorInput.addEventListener("change", () => {
                    if (variantSelectorInput.disabled) {
                      variantSelectorButton.classList.add("disabled");
                    } else {
                      variantSelectorButton.classList.remove("disabled");
                    }
                  });
                });

                nextButton.addEventListener("click", () => {
                  const slideWidth = slideElement.clientWidth;
                  slidesContainer.scrollLeft += slideWidth;

                  // Check if scrolled to the end
                  const maxScrollLeft =
                    slidesContainer.scrollWidth - slidesContainer.clientWidth;
                  if (slidesContainer.scrollLeft >= maxScrollLeft) {
                    nextButton.disabled = true;
                  } else {
                    nextButton.disabled = false;
                  }
                });

                prevButton.addEventListener("click", () => {
                  const slideWidth = slideElement.clientWidth;
                  slidesContainer.scrollLeft -= slideWidth;
                  if (slidesContainer.scrollLeft === 0) {
                    prevButton.disabled = true;
                  } else {
                    prevButton.disabled = false;
                  }
                });
              },
            });
          });
        });
      });
    }
  });
})(jQuery);
